class CartDrawer extends HTMLElement {
  constructor() {
    super();
    window.FoxTheme = window.FoxTheme || {};
    window.FoxTheme.Cart = this;
    this.drawer = this.closest("drawer-component");
    window.FoxTheme.CartDrawer = this.drawer;
    this.openWhenAdded = this.dataset.openWhenAdded === "true";

    this.onCartRefreshListener = this.onCartRefresh.bind(this);
  }

  connectedCallback() {
    window.FoxThemeEvents.subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      async (state) => {
        if (
          state.item_count !== 0 &&
          state.source !== "cart-items" &&
          state.source !== "cart-drawer-items"
        ) {
          this.renderContents(
            state,
            true,
            state.source === "quick-order-list" ? false : true
          );
        }
      }
    );

    document.addEventListener("cart:refresh", this.onCartRefreshListener);
  }

  disconnectedCallback() {
    document.removeEventListener("cart:refresh", this.onCartRefreshListener);
  }

  async onCartRefresh(event) {
    const cartDrawer = document.getElementById("cart-drawer");
    if (!cartDrawer) return;

    try {
      const response = await fetch(
        `${FoxThemeSettings.routes.root}?section_id=cart-drawer`
      );
      const responseText = await response.text();

      const parser = new DOMParser();
      const parsedHTML = parser.parseFromString(responseText, "text/html");

      const liveExpress = cartDrawer.querySelector("[data-cart-express]");
      const newCartContent = parsedHTML.getElementById("cart-drawer").innerHTML;
      cartDrawer.innerHTML = newCartContent;
      restoreCartExpressButtons(cartDrawer, liveExpress);

      if (event.detail.open === true && !this.drawer.isOpen()) {
        this.drawer.openDrawer();
      }
    } catch (error) {
      console.error("Error refreshing cart:", error);
    }
  }

  renderContents(parsedState, renderFooter = true, isOpen = true) {
    if (parsedState.errors) return;
    this.classList.contains("is-empty") && this.classList.remove("is-empty");
    const scroller = this.querySelector(".f-drawer__scroller");
    const scrollTop = scroller ? scroller.scrollTop : null;
    this.getSectionsToRender(renderFooter).forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement || !parsedState.sections[section.id]) return;

      let incomingHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );

      if (section.selector === ".f-cart-drawer__items") {
        incomingHTML = stripCartRowsFromHTML(incomingHTML, [
          ...getCartLineSync().detached.keys(),
        ]);
      }

      if (!incomingHTML && parsedState.item_count > 0) {
        return;
      }
      const liveExpress =
        section.selector === ".f-drawer__footer"
          ? sectionElement.querySelector("[data-cart-express]")
          : null;
      sectionElement.innerHTML = incomingHTML;
      restoreCartExpressButtons(sectionElement, liveExpress);
    });

    if (scroller && scrollTop !== null) {
      scroller.scrollTop = scrollTop;
    }

    setTimeout(() => {
      if (this.openWhenAdded && !this.drawer.isOpen() && isOpen) {
        this.drawer.openDrawer();
        document.body.classList.add("prevent-scroll");
        window.FoxThemeEvents.emit(`ON_CART_DRAWER_OPEN`, parsedState);
      }
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender(renderFooter = false) {
    const sections = [
      {
        id: "cart-drawer",
        selector: ".f-cart-drawer__items",
      },
    ];

    if (renderFooter) {
      sections.push({
        id: "cart-drawer",
        selector: ".f-drawer__footer",
      });
    }

    return sections;
  }
}

function restoreCartExpressButtons(root, liveExpress) {
  if (!root || !liveExpress) return;
  const slot = root.querySelector("[data-cart-express]");
  if (!slot || slot === liveExpress) return;
  slot.replaceWith(liveExpress);
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  initLoading() {
    this.loading = {
      start() {},
      finish() {},
    };
  }
  getSectionsToRender() {
    return [
      {
        id: "Drawer-Cart",
        section: "cart-drawer",
        selector: ".f-cart-drawer__items",
      },
      {
        id: "Drawer-Cart",
        section: "cart-drawer",
        selector: ".f-cart-drawer__block-subtotal",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
